import { FormContainerAdminSignUp, FormTitle, InputFlex, Label, StyledInput, InputGrid, InputDiv, FormInfo, Details, FormLink, GridDiv } from "../../../reusable_ui/styles/Forms.styled"
import { WaveTop, WaveBottom } from "../../../../assets/svg/Form/FormSvg"
import { AdminSignUpFormControl } from "./styles/SignUp.admin.styled"
import { LogoImg } from "../../NavPage/styles/NavPage.styled"
import { InputButton } from "../../../reusable_ui/styles/Button.styled"


const AdminSignUp = () => {
  return (
    <FormContainerAdminSignUp>
      <WaveTop />
      <WaveBottom />
      <GridDiv>
        <LogoImg />
        <AdminSignUpFormControl>
          <FormTitle>
            <span>Create your Account</span>
            <p>Fill the form below to set up your account.</p>
          </FormTitle>
          <InputFlex>
            <InputGrid>
              <Label>First name</Label>
              <StyledInput  type="text" placeholder='' />
            </InputGrid>
            <InputGrid>
              <Label>Last name</Label>
              <StyledInput  type="text" placeholder=''/>
            </InputGrid>
          </InputFlex>
          <InputDiv>
            <Label>Email address</Label>
            <StyledInput type='email' />
          </InputDiv>
          <InputDiv>
            <Label>Phone number</Label>
            <StyledInput type='tel' />
          </InputDiv>
          <InputDiv>
            <Label>Password</Label>
            <StyledInput type='password' />
          </InputDiv>
          <InputButton>Complete-Sign Up</InputButton>
          <FormInfo>
            <Details>Already have an account? <FormLink to='/admin/login'>Login</FormLink></Details>
          </FormInfo>
        </AdminSignUpFormControl>
      </GridDiv>
    </FormContainerAdminSignUp> 
  )
}

export default AdminSignUp 